import React from 'react'

const Contact = () => {
  return (
    <>  
            <div className="contact-section container">
                <div className="row">
                    <div className="project-text-column col-lg-12">
                        <div className="text-align-center">
                            <h2 className="section-heading">Contact me 📲</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {/* <div className="col-lg-3 col-sm-12">
                        <div className="contact-card phone-card">
                            <div className="contact-card-icon">
                                    <img src="./phone.png" alt="" />
                            </div>
                            <div className="contact-card-detail">
                                <p className="contact-heading">Phone</p>
                                <p className="contact-value">+91 9389523794</p>
                            </div>
                        </div>
                    </div> */}

                  

                    <div className="col-lg-4 col-sm-12">
                        <div data-aos="fade-right" className="contact-card phone-card">
                            <div className="contact-card-icon">
                                    <img src="./linkdin.png" alt="" />
                            </div>
                            <div className="contact-card-detail">
                                <p className="contact-heading">Linkein </p>
                                <p className="contact-value">Krishna1806</p>
                            </div>
                        </div>
                    </div>
                    <div data-aos="fade-left" className="col-lg-4 col-sm-12">
                        <div className="contact-card phone-card">
                            <div className="contact-card-icon">
                                    <img src="./email.png" alt="" />
                            </div>
                            <div className="contact-card-detail">
                                <p className="contact-heading">Email</p>
                                <p className="contact-value">krishna.web18@gmail.com</p>
                            </div>
                        </div>
                    </div>

                    <div data-aos="fade-down" className="col-lg-4 col-sm-12">
                        <div className="contact-card phone-card">
                            <div className="contact-card-icon">
                                    <img src="./location.png" alt="" />
                            </div>
                            <div className="contact-card-detail">
                                <p className="contact-heading">Location</p>
                                <p className="contact-value">Mathura,Uttar Pradesh</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
    </>
  )
}

export default Contact